import { useFormState } from '@btime/react-hooks'
import { useLoggedUser } from '@btime/react-session'
import React from 'react'

import ControlledModal from '../../../components/modals/ControlledModal'
import CreateStrongPasswordForm from './CreateStrongPasswordForm'
import ModalHeader from './ModalHeader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import ValidationsInfo from './ValidationsInfo'

const CreateStrongPasswordModal = props => {
  const user = useLoggedUser()
  let onCloseProps = {}
  if (user.hasWeakPassword) {
    onCloseProps = { onClose: false }
  }
  const [form, handleChange] = useFormState({
    repeatPassword: '',
    password: ''
  })

  return (
    <ControlledModal width="48rem" {...props} {...onCloseProps} disableHistory>
      <Separator weight={8}>
        <ModalHeader />
        <ValidationsInfo form={form} />
        <CreateStrongPasswordForm form={form} handleChange={handleChange} />
        <Separator weight={4} />
      </Separator>
    </ControlledModal>
  )
}

export default CreateStrongPasswordModal
